module.exports = __webpack_public_path__ + "img/OnArchitecture1.c199f688.jpg";